class BundleQuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.targetInput = document.getElementById(this.dataset.targetInput);
    this.buttons = Array.from(this.querySelectorAll('.bundle-quantity-selector__option'));
    this.buttons.forEach((button) => button.addEventListener('click', this.onOptionClick.bind(this)));
  }

  onOptionClick(event) {
    const button = event.currentTarget;
    const qty = parseInt(button.dataset.qty, 10);
    if (!this.targetInput || Number.isNaN(qty)) return;

    this.targetInput.value = qty;
    this.targetInput.dispatchEvent(new Event('change', { bubbles: true }));

    this.buttons.forEach((btn) => btn.classList.toggle('is-selected', btn === button));
  }
}

customElements.define('bundle-quantity-selector', BundleQuantitySelector);
